import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

export default function MarkdownHelp() {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          setShowHelp(true);
        }}
        type="button"
        className="text-sm text-primary-500 hover:text-primary-400 flex items-center gap-1"
      >
        <HelpCircle className="w-4 h-4" />
        Markdown Quick Help
      </button>

      {showHelp && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-dark-800 rounded-lg max-w-2xl w-full p-6">
            <h2 className="text-xl font-semibold mb-4">Markdown Quick Help</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="font-medium mb-2">Headings</h3>
                <div className="space-y-2 text-sm">
                  <div className="space-y-1">
                    <code className="bg-dark-700 px-2 py-1 rounded"># Heading 1</code>
                    <span className="ml-2">→ <span className="text-2xl font-bold">Heading 1</span></span>
                    <p className="text-gray-400">Creates a large, primary heading for main sections</p>
                  </div>
                  <div className="space-y-1">
                    <code className="bg-dark-700 px-2 py-1 rounded">## Heading 2</code>
                    <span className="ml-2">→ <span className="text-xl font-bold">Heading 2</span></span>
                    <p className="text-gray-400">Creates a medium heading for subsections</p>
                  </div>
                  <div className="space-y-1">
                    <code className="bg-dark-700 px-2 py-1 rounded">### Heading 3</code>
                    <span className="ml-2">→ <span className="text-lg font-bold">Heading 3</span></span>
                    <p className="text-gray-400">Creates a smaller heading for nested subsections</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-medium mb-2">Basic Formatting</h3>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div className="space-y-1">
                    <code className="bg-dark-700 px-2 py-1 rounded">**bold**</code>
                    <span className="ml-2">→ <strong>bold</strong></span>
                    <p className="text-gray-400">Makes text stand out with strong emphasis</p>
                  </div>
                  <div className="space-y-1">
                    <code className="bg-dark-700 px-2 py-1 rounded">*italic*</code>
                    <span className="ml-2">→ <em>italic</em></span>
                    <p className="text-gray-400">Adds subtle emphasis to text</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-medium mb-2">Lists</h3>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div className="space-y-1">
                    <code className="bg-dark-700 px-2 py-1 rounded">- item</code>
                    <span className="ml-2">→ bullet list</span>
                    <p className="text-gray-400">Creates an unordered list for items without sequence</p>
                  </div>
                  <div className="space-y-1">
                    <code className="bg-dark-700 px-2 py-1 rounded">1. item</code>
                    <span className="ml-2">→ numbered list</span>
                    <p className="text-gray-400">Creates an ordered list for sequential items</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-medium mb-2">Links</h3>
                <div className="text-sm space-y-1">
                  <code className="bg-dark-700 px-2 py-1 rounded">[text](url)</code>
                  <span className="ml-2">→ clickable link</span>
                  <p className="text-gray-400">Creates a clickable link where "text" is displayed and "url" is the destination</p>
                </div>
              </div>

              <div>
                <h3 className="font-medium mb-2">Example</h3>
                <p className="text-sm text-gray-400 mb-2">Here's a practical example combining multiple Markdown elements:</p>
                <pre className="bg-dark-700 p-3 rounded-lg text-sm">
                  # Meeting Notes{'\n\n'}
                  ## Discussion Points{'\n\n'}
                  - Discussed project timeline{'\n'}
                  - Next steps:{'\n'}
                  1. Review proposal{'\n'}
                  2. Schedule follow-up{'\n\n'}
                  ### Action Items{'\n\n'}
                  *Important:* [View document](url)
                </pre>
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                onClick={() => setShowHelp(false)}
                className="btn btn-primary"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}